module.exports = __webpack_public_path__ + "img/notice.945ff083.png";